var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 9.1668V13.3335M10.0007 9.1668L6.66732 7.50014M10.0007 9.1668L13.334 7.50014M9.81431 17.407L3.56431 14.282C3.42315 14.2114 3.33398 14.0671 3.33398 13.9093V6.09098C3.33398 5.93316 3.42315 5.78888 3.56431 5.7183L9.81431 2.59331C9.93162 2.53465 10.0697 2.53465 10.187 2.59331L16.437 5.7183C16.5781 5.78888 16.6673 5.93316 16.6673 6.09098V13.9093C16.6673 14.0671 16.5781 14.2114 16.437 14.282L10.187 17.407C10.0697 17.4656 9.93162 17.4656 9.81431 17.407Z",
    stroke: "#D7DFE9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.7c477c8c666e8233ae477fc4d2d570db.svg";
export { ForwardRef as ReactComponent };